import { Injectable } from '@angular/core';
import { AmplifyApiService } from '@nx/amplify-api';
import { Observable } from 'rxjs';
import { EnquiryMessage } from '../interfaces/enquiry-message.interface';

@Injectable({
  providedIn: 'root'
})
export class EnquiryService {

  constructor(private amplifyApiService: AmplifyApiService) { }

  public sendEnquiryEmail(enquiry:EnquiryMessage) :Observable<any> {
    return this.amplifyApiService.publicPost('/core-new/send-enquiry-email', enquiry);
  }

}
